import React, { useEffect, useState } from 'react';
import { classNames } from 'assets/utils/helper';
import GetViewportSize from '../../assets/utils/getViewportSize';
import Icons from 'components/atoms/Icons';
import { Field, LinkField, Link } from '@sitecore-jss/sitecore-jss-nextjs';

type HeaderModalProps = {
  fields: {
    ButtonText: Field<string>;
    Subheading: Field<string>;
    Subtext: Field<string>;
    Link1: LinkField;
    Link2: LinkField;
  };
};

const HeaderModal = (props: HeaderModalProps) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [viewportSize, setViewportSize] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const handleClick = () => setPopupOpen(true);

  const { ButtonText, Subheading, Subtext, Link1, Link2 } = props.fields;

  useEffect(() => {
    window.addEventListener('click', e => {
      if (!(e.target as HTMLElement).closest('.header-modal')) {
        setPopupOpen(false);
      }
    });
    setViewportSize(GetViewportSize());
    const handleResize = () => setViewportSize(GetViewportSize());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (viewportSize !== 'xl' && viewportSize !== 'xxl') {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [viewportSize]);

  return (
    <div className="overhauled">
      <div
        className={classNames(
          'header-modal',
          isMobile ? 'nav-action has-sub-nav' : '',
          popupOpen ? 'active' : ''
        )}
      >
        <button
          type="button"
          className="btn-primary no-icon header-modal-btn"
          onClick={() => handleClick()}
        >
          {ButtonText.value}
        </button>
        <div
          className={classNames(
            isMobile ? 'sub-nav-menu header-modal-popup' : 'header-modal-popup',
            !popupOpen ? 'closed' : 'open active'
          )}
          {...(!isMobile && {
            onMouseLeave: () => {
              setPopupOpen(false);
            },
          })}
        >
          {isMobile && popupOpen && (
            <div className="sub-link-item">
              <div
                className="sub-link-heading"
                tabIndex={0}
                onClick={() => setPopupOpen(false)}
              >
                <Icons id="chevron-left-icon" />
                {ButtonText.value}
              </div>
            </div>
          )}
          <div className="popup-details">
            <p className="osf-nav-section-titles color-primary-dark">
              {Subheading.value}
            </p>
            <p className="osf-nav-top-level color-primary-dark">
              {Subtext.value}
            </p>
            <Link field={Link1} className="btn-secondary no-icon"></Link>
            <Link field={Link2} className="btn-secondary no-icon"></Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderModal;
